export default {
  namespaced: true,
  state: {
    socket: null,
    message: null,
    error: null,
    isClosed: null,
    isConnecting: null,
  },
  getters: {
    getMessage(state) {
      return state.message;
    },
    getError(state) {
      return state.error;
    },
    getIsClosed(state) {
      return state.isClosed;
    },
    getIsConnecting(state) {
      return state.isConnecting;
    },
  },
  mutations: {
    setSocket(state, payload) {
      state.socket = payload;
    },
    setMessage(state, payload) {
      state.message = payload;
    },
    setSocketError(state, payload) {
      state.error = payload;
    },
    setIsClosed(state, payload) {
      state.isClosed = payload;
    },
    setIsConnecting(state, payload) {
      state.isConnecting = payload;
    },
  },
  actions: {
    connect({ state, commit }, wsUrl) {
      // 1 - means connection is established and communication is possible.
      if (state.socket && state.socket.readyState === 1) return state.socket;

      const socket = new WebSocket(wsUrl);
      commit('setSocket', socket);

      if (state.socket.readyState === 0) {
        commit('setIsConnecting', true);
      }

      socket.onopen = () => {
        commit('setSocketError', null);
        commit('setIsClosed', false);
        commit('setIsConnecting', false);
      };

      socket.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          commit('setMessage', message);
        } catch (error) {
          commit('setSocketError', error);
        } finally {
          commit('setIsConnecting', false);
        }
      };

      socket.onerror = (event) => {
        commit('setSocketError', event.data);
        commit('setIsClosed', true);
        commit('setIsConnecting', false);
        commit('setSocket', null);
      };

      socket.onclose = () => {
        commit('setIsClosed', true);
        commit('setIsConnecting', false);
        commit('setSocket', null);
        commit('setSocketError', null);
        commit('setMessage', null);
      };

      return '';
    },
    disconnect({ state, commit }) {
      if (state.socket) {
        state.socket.close();
        commit('setIsClosed', true);
        commit('setSocket', null);
        commit('setSocketError', null);
        commit('setMessage', null);
      }
    },
  },
};
